import detectIe from 'detectie';


const fixSvg = root => {
    const svgArr = [...root.querySelectorAll('svg.svg-inline')];
    svgArr.filter(svg => svg.getAttribute('svg-fix') !== true);

    svgArr.forEach(svg => {
        svg.setAttribute('preserveAspectRatio', 'xMidYMin slice');
        const viewBox = svg.getAttribute('viewBox').split(' ');
        const padding = viewBox[3] / viewBox[2] * 100;
        svg.style.paddingBottom = padding + '%';
        svg.style.height = '1px';
        svg.style.overflow = 'visible';
        svg.setAttribute('svg-fix', true);
    });
};


const init = () => {
    if (detectIe()) {
        document.body.setAttribute('ie', true);
        fixSvg(document);
    }
};

export default {
    init
};


// WEBPACK FOOTER //
// ./js/ie-fix.js